<template>
  <div>
    <div class="listbox">
      <router-link :to="{ name: 'details', query: { id: item.id } }" target="_blank" v-for="(item, index) in list"
        class="item">
        <div class="tit" v-html="item.title"></div>
        <div class="con">
          {{ item.nowCateName ? item.nowCateName.join('-') : '' }}
          <!-- <img src="@/assets/img/time.png" alt="" class="ico">
          {{ item.create_time }} -->
        </div>
      </router-link>
      <!-- <div v-for="(item, index) in list" @click="toDetails(item)" class="item">
        <div class="tit" v-html="item.title"></div>
        <div class="con">
          {{ item.nowCateName ? item.nowCateName.join('-') : '' }}
          <img src="@/assets/img/time.png" alt="" class="ico">
          {{ item.create_time }}
        </div>
      </div> -->
    </div>
    <div v-if="isAjax && total == 0" class="nodata">暂无数据</div>
    <div v-if="wW <= 1259" class="ismobile">
      <div v-if="total > 0" class="per_pagebox ">
        <!-- :show-total="total => `共 ${total} 条`" -->
        <a-pagination size="small" show-size-changer show-quick-jumper :current="page" :pageSize="limit" :total="total"
          @showSizeChange="onShowSizeChange" @change="onChange" />
        <div class="total">共{{ total }}条</div>
      </div>
    </div>
    <div v-if="wW >= 1260" class="ispc">
      <div v-if="total > 0" class="per_pagebox ">
        <!-- :show-total="total => `共 ${total} 条`" -->
        <a-pagination show-size-changer show-quick-jumper :current="page" :pageSize="limit" :total="total"
          @showSizeChange="onShowSizeChange" @change="onChange" />
        <div class="total">共{{ total }}条</div>
      </div>
    </div>
  </div>
</template>

<script>
import { supplierRuleList } from "@/server/api/index"
export default {
  name: '',
  components: {},
  props: {
    nowCateItem: Object,
    nowCateName: Array,
    article_title: String,
    menuList: Array,
    module: Number,
    navName: String,
    nowTime: Number,
  },
  data() {
    return {
      wW: document.body.clientWidth,
      limit: 10,
      page: 1,
      total: 0,

      list: [],
      isAjax: false
    };
  },
  created() {
    // console.log('created')
    this.init()
  },
  watch: {
    nowTime(val) {
      // console.log('nowTime', val)
      this.init()
    },
  },
  methods: {
    onShowSizeChange(page, limit) {
      // console.log('onShowSizeChange',page, limit);
      this.page = page
      this.limit = limit
      this.getList()
    },
    onChange(page, limit) {
      // console.log('onChange',page, limit);
      this.page = page
      this.limit = limit
      this.getList()
    },

    toDetails(item) {
      // console.log('????')
      this.$router.push({ name: 'details', query: { id: item.id } })
    },

    init() {
      this.page = 1
      this.getList()
    },
    //str 要传入的字符串  key 代表要高亮的字符串
    heightLight(str, key) {
      const reg = new RegExp(key, 'ig')
      return str.replace(reg, (val) => {
        return `<span style="color:red">${val}</span>`
      })
    },
    getList() {
      this.isAjax = false
      let data = {
        page: this.page,
        limit: this.limit,
        module: this.module
      }
      // module	是	所属模块，10规则中心，20帮助中心
      if (this.nowCateItem.id) {
        data.article_category_id = this.nowCateItem.id
      }
      if (this.article_title) {
        data.article_title = this.article_title
      }
      supplierRuleList(data).then(res => {
        this.isAjax = true
        if (this.page == 1) {
          document.documentElement.scrollTop = 0
        }
        // this.page = res.data.list.current_page
        this.total = res.data.list.total
        // console.log('this.nowCateName',this.nowCateName,this.nowCateName.length)
        res.data.list.data.map((item, k) => {
          if (this.article_title) {
            item.title = this.heightLight(item.title, this.article_title)
          }
          let key = []
          let nowCateName = []
          this.menuList.findIndex((v, k) => {
            if (v.id == item.article_category_id) {
              key = [k]
              nowCateName = [v.name]
              return true
            } else {
              let hasn = v.category.findIndex((m, n) => {
                key = [k, n]
                nowCateName = [v.name, m.name]
                return m.id == item.article_category_id
              })
              return hasn >= 0
            }
          })
          item.nowCateName = nowCateName
        })
        this.list = res.data.list.data
      })
    }
  }
}
</script>

<style lang='less' scoped>
.nodata {
  padding: 15px;
}

.listbox {
  padding: 0 15px;

  .item {
    display: block;
    border-bottom: 1px solid #EFEFEF;
    padding: 20px 0;

    .tit {
      font-size: 18px;
      color: #222222;
      font-weight: bold;
      cursor: pointer;
    }

    .con {
      padding-top: 15px;
      font-size: 16px;
      color: #999999;
      display: flex;
      align-items: center;

      .ico {
        margin-left: 22px;
        margin-right: 6px;
        width: 14px;
        display: block;
      }
    }
  }
}

.per_pagebox {
  font-size: 14px;
  color: #222222;
  padding: 27px 0 20px 15px;
  display: flex;
  align-items: center;

  .total {
    margin-left: 15px;
    color: #222222;
  }
}

@media screen and (max-width: 1259px) {
  .listbox {
    padding-top: 8px;

    .item {
      padding: 15px 0;

      .tit {
        font-size: 16px;
      }

      .con {
        font-size: 12px;
      }
    }
  }

  .per_pagebox {
    .total {
      font-size: 12px;
    }
  }
}
</style>
